module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAA0klEQVQoU2NkwAJmzJhhx8jIuIyZmdk6JSXlIUwJIzbFs2bNKvr//38vExNTSWpqai9OxZMmTWIHggtABRpAXJOent6KU/HMmTMnAiXzQAqAJkcBTV4OVwx0XwlQUBlo7VkgZgK6dSaS09YC+a+h/NOMQMXHgQIWQIX7gPRhoEQ9Nn8A5U8wAq3dDpT0IELxXJBikJsiiFCcwggMpulAhRmEFAP9pQQyuR1ocgU+xUC/3EpLS1MHKS4EKu4D4u1A3XP+/fu3BMjmRPYkUHExUHEfAFMAZExfWTmhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dz.png
// module id = 6ExE
// module chunks = 15